import { ISurveyAnswerOption } from "@common/models/CMS/SurveyAnswerOption";
import { ISurveyMultiAnswer, ISurveySingleAnswer } from "@common/models/SurveyConfirm";
import { ISurveyGroup } from "@common/models/CMS/SurveyGroup"
import { FC } from "react"
import { SurveyQuestionMultiAnswer, SurveyQuestionSingleAnswer } from "./index"
import { emojies } from "./SurveyQuestionSingleAnswer"

interface ISurveyGroupProps {
    surveyGroup: ISurveyGroup;
    className?: string;
    multiAnswers: ISurveyMultiAnswer[];
    singleAnswers: ISurveySingleAnswer[];
    onChangeMultiAnswer: (questionId: number, answer: ISurveyAnswerOption) => void;
    onChangeSingleAnswer: (questionId: number, answer: ISurveyAnswerOption) => void;
}

export const SurveyGroup: FC<ISurveyGroupProps> = ({ multiAnswers, singleAnswers, surveyGroup, className, onChangeMultiAnswer, onChangeSingleAnswer }) => {
    const answersLabel = surveyGroup.bag.contentItems.find(question => question.bag.contentItems.find(answer => emojies.find(x => x === answer.id)));

    return (
        <div className={`survey-group ${className || ""}`}>
            <header className="row flex flex-center flex flex-no-wrap flex-grow justify-between">
                <h2 className="col-1-auto title-header title-bottom">{surveyGroup.displayText}</h2>
                {
                    answersLabel ?
                        <section className="col-1-auto">
                            <div className="row flex spa-1 flex-no-wrap">
                                {answersLabel.bag.contentItems.map(answer => <div key={answer.id} className="col-1-auto emoji-answer-item">{answer.displayText}</div>)}
                            </div>
                        </section>
                        : ""
                }

            </header>
            <main className="row flex spa-2">
                {
                    surveyGroup.bag.contentItems.map(question => question.multiSelect ? <SurveyQuestionMultiAnswer
                        key={question.id}
                        multiAnswers={multiAnswers}
                        question={question}
                        onChangeMultiAnswer={onChangeMultiAnswer}
                        className={`col-1-${surveyGroup.colspan}`}
                    />
                        : <SurveyQuestionSingleAnswer
                            key={question.id}
                            singleAnswers={singleAnswers}
                            onChangeSingleAnswer={onChangeSingleAnswer}
                            question={question}
                            className={`col-1-${surveyGroup.colspan}`}
                        />
                    )
                }
            </main>
        </div >
    )
}